import { createAsyncThunk, createSlice, createSelector } from "@reduxjs/toolkit";
import {addTransactionNote, getTransactionByNum} from "../../service/api";

const initialState = {
  transactions: [],
  transaction: {
    selectedTab: "Info",
    info: {},
    documents: [],
    history: [],
  },
};

export const selectTransactionRisk = createSelector(
  (state) => state?.score_color || state?.transaction?.score_color,
  (scoreColor) => {
    if (scoreColor === "red") {
      return "High";
    } else if (scoreColor === "yellow") {
      return "Medium";
    } else if (scoreColor === "green") {
      return "Low";
    } else {
      return "";
    }
  }
);

export const doAddTransactionNote = createAsyncThunk(
    "transactions/addTransactionNote",
    async (num,note) => {
      const { data } = await addTransactionNote(num, note);
      return data;
    }
);

export const fetchTransactionById = createAsyncThunk(
  "transactions/getTransactionByNum",
  async (num) => {
    const { data } = await getTransactionByNum(num);
    return data;
  }
);
export const transactionsSlice = createSlice({
  name: "transactions",
  initialState,
  reducers: {
    setTransactions: (state, action) => {
      state.transactions = action.payload;
    },
    setTransactionInfo: (state, action) => {
      state.transaction.info = action.payload;
    },
    setTransactionHistory: (state, action) => {
      state.transaction.history = action.payload;
    },
    setTransactionSelectedTab: (state, action) => {
      state.transaction.selectedTab = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTransactionById.fulfilled, (state, action) => {
      state.transaction.info = action.payload;
    });
  },
});

export const {
  setTransactionDocuments,
  setTransactionHistory,
  setTransactionInfo,
  setTransactions,
  setTransactionSelectedTab,
} = transactionsSlice.actions;

export default transactionsSlice.reducer;
